/**
 * Copyright (c) 2025 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { fonts, mixins } from '@blend/consumer-components/dist/consumer-components';

interface SignatureMetadata {
  fileBase64: string;
}

const styles = StyleSheet.create({
  signatureContainerRow: {
    display: 'flex',
    width: '100%',
    ...mixins.margin(0, 0, 20, 0),
    ':last-child': {
      ...mixins.margin(0),
    },
  },
  signatureImage: {
    width: 'auto',
    height: 70,
  },
  signatureLabel: {
    width: '40%',
    fontWeight: fonts.weight.book,
  },
  signaturePlaceholder: {
    width: '60%',
    fontWeight: fonts.weight.bold,
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
});

const JournalPrincipalSignature = ({ signatureMetadata }: { signatureMetadata: SignatureMetadata }) => {
  return (
    <tr className={css(styles.signatureContainerRow)}>
      <th className={css(styles.signatureLabel)}>Signature</th>
      {signatureMetadata?.fileBase64 ? (
        <td>
          <img src={signatureMetadata.fileBase64} alt="Signature" className={css(styles.signatureImage)} />
        </td>
      ) : (
        <td className={css(styles.signaturePlaceholder)}>No signature available</td>
      )}
    </tr>
  );
};

export default JournalPrincipalSignature;
